import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { LatestDiscussionResponse } from "../../../models/external/latest-discussion-model";
import useAuth from "../../../hooks/useAuth";

type CardCarouselType = {
  title: string;
  link: string;
  articles: LatestDiscussionResponse[][];
  includeSubscribe: boolean;
};

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const CardCarouselExchange = (props: CardCarouselType) => {
  const { link, title, articles, includeSubscribe } = props;

  const user = useAuth().getUser();
  const ssoToken = user ? user.ssoToken : null;

  return (
    <>
      <div className="row mb-2">
        <div className="col-lg-8 col-md-6">
          <h2 className="titlecolor">
            <a href={`https://connect.raps.org/home${ssoToken ? "?sso=" + ssoToken : ""}`}>{title} »</a>
          </h2>
        </div>
        {includeSubscribe && (
          <div className="col-lg-4 col-md-6 col-sm-5 col-xs-12 text-right">
            <a href="/preferences" className="more-off btn btn-sm btn-default">
              <span className="titlecolor">Subscribe</span>
            </a>
          </div>
        )}

        <div className="clear"></div>
      </div>

      <Carousel fade controls={false} className="mb-5">
        {articles.map((article) => {
          return article.map((item, index) => {
            
            let largePictureUrl = item.author.largePictureUrl;
            let displayName = item.author.displayName;
            let linkToProfile = item.author.linkToProfile;
            let linkToDiscussion = item.linkToDiscussion;
            let discussionName = item.discussionName;
            let linkToMessage = item.linkToMessage;
            let message = item.bodyWithoutMarkup.substring(0, 150) + "...";
            let subject = item.subject;

            let datePosted = new Date(item.datePosted);
            let hours = datePosted.getHours();
            let minutes = datePosted.getMinutes();
            let ampm = hours >= 12 ? 'pm' : 'am';
            
            let adjustedHours = hours % 12;
            adjustedHours = adjustedHours ? adjustedHours : 12;
            let adjustedMinutes = minutes < 10 ? '0'+minutes : minutes;

            var formattedTime = adjustedHours + ':' + adjustedMinutes + ' ' + ampm;
            let formattedDate = datePosted.getDate() + " " + monthNames[datePosted.getMonth()] + " " + datePosted.getFullYear() + " " + formattedTime

            return (
              <Carousel.Item key={index}>
                <div className="single-item box-shadow-off box-border margin-bottom-30 margon-top-risk rfitem-0" aria-hidden="false">
                    <div className="re-thumb borderregex">
                        <img style={{ minHeight: 90, minWidth: 90 }} src={largePictureUrl} alt={displayName} />
                    </div>
                    <p className="re-auth-meta">
                        {" "}By{" "}
                        <a href={linkToProfile}>{displayName}</a>
                        <br />
                        {" "}{formattedDate}{" "}
                        <br />
                        <a href={linkToDiscussion}>
                            <b>{discussionName}</b>
                        </a>
                    </p>
                  
                  <div className="clear margin-bottom-reg"></div>
                  <a href={linkToMessage}>
                    <strong>{subject}</strong>
                  </a>
                  <p className="lineheightreduced margintop">
                    {message}
                  </p>
                  <a href={linkToMessage}>
                    <span className="btn btn-more"></span>
                  </a>
                </div>
              </Carousel.Item>
            );
          });
        })}
      </Carousel>
    </>
  );
};

export default CardCarouselExchange;
